import React, { useState } from 'react';
import { Products, Review, Shipping } from '../..';
import { useUser } from '../../../Context/User';
import { PopupModal } from '../../../Modals/Index';
import './style.css';
const Index = ({ state, setStateFalse, setStateFalseWithClearCart }) => {
    const { orderStep, setOrderStep } = useUser();

    return (
        <PopupModal setStateFalse={setStateFalseWithClearCart} state={state}>
            <div className="popupConatiner">
                <div className="home_head flex-start">
                    <p style={{ marginRight: '5px' }} className={`home_heading ${orderStep >= 0 ? 'active' : ''}`}>
                        Products
                    </p>{' '}
                    |
                    <p
                        style={{ marginRight: '5px', marginLeft: '5px' }}
                        className={`home_heading ${orderStep >= 1 ? 'active' : ''}`}
                    >
                        {' '}
                        Shippings{' '}
                    </p>
                    |
                    <p style={{ marginLeft: '5px' }} className={`home_heading ${orderStep >= 2 ? 'active' : ''}`}>
                        {' '}
                        Reviews
                    </p>
                </div>
                <div className="popup_body">
                    {orderStep === 0 ? (
                        <Products
                            addMore={() => {
                                setStateFalse();
                            }}
                            next={() => {
                                setOrderStep((prev) => prev + 1);
                            }}
                            prev={setStateFalseWithClearCart}
                        />
                    ) : orderStep === 1 ? (
                        <Shipping
                            next={() => {
                                setOrderStep((prev) => prev + 1);
                            }}
                            prev={() => {
                                setOrderStep((prev) => prev - 1);
                            }}
                        />
                    ) : (
                        <Review
                            addMore={() => {
                                setStateFalse();
                            }}
                            next={() => {
                                setStateFalseWithClearCart();
                            }}
                            prev={() => {
                                setOrderStep((prev) => prev - 1);
                            }}
                        />
                    )}
                </div>
            </div>
        </PopupModal>
    );
};

export default Index;
